import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
var _excluded = ["className", "style"];
import React from 'react';
import cn from 'classnames';
import { sstyled } from 'intergalactic/core';
import useBox, { removeUndefinedKeys } from '../Box/useBox';
/*__reshadow-styles__:"../style/use-flex.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SFlex_n3dnq_gg_{display:flex}.___SFlex_n3dnq_gg_.__inline_n3dnq_gg_{display:inline-flex}" /*__inner_css_end__*/, "n3dnq_gg_") /*__reshadow_css_end__*/, {
  "__SFlex": "___SFlex_n3dnq_gg_",
  "_inline": "__inline_n3dnq_gg_"
});
import { getAutoOrScaleIndent } from '../utils';
function calculateFlexStyles(props) {
  var _props$scaleIndent;
  var DirectionReverse = {
    row: 'row-reverse',
    column: 'column-reverse'
  };
  var scaleIndent = (_props$scaleIndent = props.scaleIndent) !== null && _props$scaleIndent !== void 0 ? _props$scaleIndent : 4;
  return removeUndefinedKeys({
    alignItems: props.alignItems,
    alignContent: props.alignContent,
    justifyContent: props.justifyContent,
    flexWrap: props.flexWrap ? "wrap".concat(props.reverse ? '-reverse' : '') : undefined,
    flexDirection: props.reverse && DirectionReverse[props.direction] || props.direction,
    rowGap: getAutoOrScaleIndent(props.rowGap || props.gap, scaleIndent),
    columnGap: getAutoOrScaleIndent(props.columnGap || props.gap, scaleIndent)
  });
}
export default function useFlex(props, ref) {
  var _useBox = useBox(_objectSpread(_objectSpread({
      'data-ui-name': 'Flex'
    }, props), {}, {
      inline: false
    }), ref),
    _useBox2 = _slicedToArray(_useBox, 2),
    Tag = _useBox2[0],
    _useBox2$ = _useBox2[1],
    className = _useBox2$.className,
    styleProp = _useBox2$.style,
    other = _objectWithoutProperties(_useBox2$, _excluded);
  var inline = props.inline,
    flexWrap = props.flexWrap,
    direction = props.direction,
    reverse = props.reverse,
    alignItems = props.alignItems,
    alignContent = props.alignContent,
    justifyContent = props.justifyContent,
    gap = props.gap,
    rowGap = props.rowGap,
    columnGap = props.columnGap,
    scaleIndent = props.scaleIndent;
  var flexStyles = React.useMemo(function () {
    return calculateFlexStyles(props);
  }, [flexWrap, direction, reverse, alignItems, alignContent, justifyContent, gap, rowGap, columnGap, scaleIndent]);
  var styles = sstyled(style);
  if (Tag === React.Fragment) return [React.Fragment, {
    children: props.children
  }];
  return [Tag, _objectSpread({
    className: cn(styles.cn('SFlex', {
      inline: inline
    }).className, className) || undefined,
    style: Object.assign({}, styleProp, flexStyles)
  }, other)];
}
//# sourceMappingURL=useFlex.js.map